import {
    CUSTOMERS,
    DASHBOARD,
    DEVICES,
    MANAGE_SITE_FROM_DEVICE,
    MYORG,
    PROFILE,
    HOME,
    STYLEGUIDE,
    SITE,
    MANAGE_SITE_FROM_CUSTOMERS,
    SERVICER,
    PAGE_404,
    SETTINGS,
    MANAGE_SITE,
    MANAGE_COMMANDS_FROM_DEVICE,
    MANAGE_COMMANDS_FROM_CUSTOMERS,
    DEVICE_SITE,
    CUSTOMER_SITE,
    DEVICE_COMMAND,
    CUSTOMER_COMMAND,
    FIRMWARES,
    MANAGE_USERS,
    USERS,
    MANAGE_MFA,
    SPATIALVIEW,
    SPATIALVIEWER,
    MANAGE_SPATIALVIEWER,
    MANAGE_SPATIALVIEW_FROM_DEVICE,
    DEVICE_SPATIALVIEW,
    MANAGE_SPATIALVIEWER_FROM_DEVICE,
    DEVICE_SPATIALVIEWER,
    OPERATIONS,
    MANAGE_OPERATIONS,
    MANAGE_OPERATIONS_FROM_DEVICE,
    DEVICE_OPERATIONS,
} from 'containers/urlConstant';
import React from 'react';
import { SITE_HEIRARCHY_COMMAND_TEXT, VIEW_USERS } from 'shared/utils/Constants';

const Dashboard = React.lazy(() => import('./views/dashboard/Dashboard'));
const CustomerOrg = React.lazy(() => import('./views/organization/customer'));
const Devices = React.lazy(() => import('./views/devices/Device'));
const MyOrg = React.lazy(() => import('./views/myorg'));
const Profile = React.lazy(() => import('./views/profile'));
const ManageSites = React.lazy(() => import('./views/managesite'));
const StyleGuide = React.lazy(() => import('./views/styleguide/Styleguide'));
const Servicer = React.lazy(() => import('./views/organization/servicer'));
const Page404 = React.lazy(() => import('./views/auth/page404/Page404'));
const Setting = React.lazy(() => import('./views/setting/Settings'));
const Commands = React.lazy(() => import('./views/deviceCommands/component/DeviceCommands'));
const Firmware = React.lazy(() => import('./views/firmwares/component/Firmwares'));
const Users = React.lazy(() => import('./views/organization/component/ViewUsers'));
const Managemfa = React.lazy(() => import('./views/mfa/ManageMFA'));
const SpatailView = React.lazy(() => import('./views/spatialview/component/SpatialView'));
const SpatailViewer = React.lazy(() => import('./views/spatialview/component/SpatialViewerPage'));
const OperationsPage = React.lazy(() => import('./views/spatialview/component/Operations'));


const SITE_HEIRARCHY_TEXT = 'Site Navigation';

export const common_routes = [
    { path: HOME, exact: true, name: 'Home', mainRoute: HOME, icon: 'ri-home-2-line' },
    { path: PROFILE, name: 'Profile', component: Profile, mainRoute: PROFILE, icon: 'ri-profile-line' },
    { path: STYLEGUIDE, name: 'StyleGuide', component: StyleGuide, mainRoute: STYLEGUIDE, icon: 'ri-booklet-line' },
    { path: PAGE_404, name: '404', component: Page404, mainRoute: PAGE_404, icon: 'ri-stop-circle-line' },
    { path: SETTINGS, name: 'Settings', component: Setting, mainRoute: SETTINGS, icon: 'ri-settings-3-line' },
];
export const OrgRoute = { path: MYORG, name: 'My Organization', component: MyOrg, mainRoute: MYORG, icon: 'ri-building-line' };
export const ManageMFA = { path: MANAGE_MFA, name: 'Manage MFA', component: Managemfa, mainRoute: MANAGE_MFA, icon: 'ri-fingerprint-line' };
export const DashboardRoute = { path: DASHBOARD, name: 'Dashboard', component: Dashboard, mainRoute: DASHBOARD, icon: 'ri-dashboard-3-line' };
export const ManageSiteRoute = {
    path: MANAGE_SITE,
    name: SITE_HEIRARCHY_TEXT,
    component: ManageSites,
    mainRoute: SITE,
    exact: true,
    icon: 'ri-node-tree'
};
export const ManageSiteRouteFromDeviceRoute = {
    path: MANAGE_SITE_FROM_DEVICE,
    name: SITE_HEIRARCHY_TEXT,
    component: ManageSites,
    mainRoute: DEVICE_SITE,
    exact: true,
    icon: 'ri-node-tree'
};
export const ManageSpatialViewRouteFromDeviceRoute = {
    path: MANAGE_SPATIALVIEW_FROM_DEVICE,
    name: 'Spatial View',
    component: SpatailView,
    mainRoute: DEVICE_SPATIALVIEW,
    exact: true,
    icon: 'ri-box-3-line'
};
export const ManageSpatialViewerFromDeviceRoute = {
    path: MANAGE_SPATIALVIEWER_FROM_DEVICE,
    name: 'View Space',
    component: SpatailViewer,
    mainRoute: DEVICE_SPATIALVIEWER,
    exact: true,
    icon: 'ri-home-office-line'
};
export const ManageOperationsFromDeviceRoute = {
    path: MANAGE_OPERATIONS_FROM_DEVICE,
    name: 'Operations',
    component: OperationsPage,
    mainRoute: DEVICE_OPERATIONS,
    exact: true,
    icon: 'ri-equalizer-fill'
};
export const ManageCommandsFromDeviceRoute = {
    path: MANAGE_COMMANDS_FROM_DEVICE,
    name: SITE_HEIRARCHY_COMMAND_TEXT,
    component: Commands,
    mainRoute: DEVICE_COMMAND,
    exact: true,
    icon: 'ri-command-line'
};
export const ManageUsers = {
    path: MANAGE_USERS,
    name: VIEW_USERS,
    component: Users,
    mainRoute: USERS,
    exact: true,
    icon: 'ri-group-3-line'
};

const routes = [
    DashboardRoute,
    OrgRoute,
    ManageMFA,
    ManageSiteRouteFromDeviceRoute,
    ManageCommandsFromDeviceRoute,
    ManageSpatialViewRouteFromDeviceRoute,
    ManageSpatialViewerFromDeviceRoute,
    ManageOperationsFromDeviceRoute,
    {
        path: MANAGE_SITE_FROM_CUSTOMERS,
        name: SITE_HEIRARCHY_TEXT,
        component: ManageSites,
        mainRoute: CUSTOMER_SITE,
        exact: true,
        icon: 'ri-node-tree'

    },
    {
        path: MANAGE_COMMANDS_FROM_CUSTOMERS,
        name: SITE_HEIRARCHY_COMMAND_TEXT,
        component: Commands,
        mainRoute: CUSTOMER_COMMAND,
        exact: true,
        icon: 'ri-command-line'

    },

    { path: DEVICES, name: 'Devices', component: Devices, mainRoute: DEVICES, icon: 'ri-device-line' },
    { path: SERVICER, name: 'Servicers', component: Servicer, mainRoute: SERVICER, icon: 'ri-user-shared-line' },
];

export const spatialview_routes = [
    {
        path: SPATIALVIEW, name: 'Spatial View', component: SpatailView, mainRoute: SPATIALVIEW, exact: true,
        icon: 'ri-box-3-line'

    },
    { path: MANAGE_SPATIALVIEWER, name: 'View Space', component: SpatailViewer, mainRoute: SPATIALVIEWER, exact: true,
    icon: 'ri-home-office-line'

     },
    { path: MANAGE_OPERATIONS, name: 'Operations', component: OperationsPage, mainRoute: OPERATIONS, exact: true,
    icon: 'ri-equalizer-fill'

     },
    ManageSpatialViewRouteFromDeviceRoute,
    ManageSpatialViewerFromDeviceRoute,
    ManageOperationsFromDeviceRoute
];

export const super_routes = [
    ManageUsers,
    ...spatialview_routes,
    { path: CUSTOMERS, name: 'Customers', component: CustomerOrg, mainRoute: CUSTOMERS,icon:'ri-group-line' },
    { path: FIRMWARES, name: 'Firmwares', component: Firmware, mainRoute: FIRMWARES,icon:'ri-file-zip-line' },
];
export default routes;
